import { API } from '.';
import QueryString from 'qs';
import { Utils } from '../helpers/Utils';

class MeetingService {
    async getCoachMeetings(coachId) {
        const currentDate = Date.now();
        const startOfDay = new Date(currentDate);
        startOfDay.setHours(0, 0, 0, 0);
        const startOfDayISO = startOfDay.toISOString();

        const meetingsQuery = QueryString.stringify(
            {
                filters: {
                    contact: { coach: { id: coachId } },
                    $and: [
                        { meetingTime: { $notNull: true } },
                        { meetingTime: { $gte: startOfDayISO } },
                    ],
                },
                populate: { contact: { fields: ['firstName', 'lastName'] } },
                sort: ['meetingTime:asc'],
            },
            { encodeValuesOnly: true },
        );

        const response = await API.get(`/api/meetings?${meetingsQuery}`);
        if (!response) return [];
        var data = Utils.deepFlatten(response.data.data);
        return data;
    }
}

export default MeetingService;
